import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { Sparkles, Heart, Award } from 'lucide-react';

const About = ({ cartCount }) => {
  return (
    <div className="min-h-screen bg-black">
      <SEO 
        title="About Us"
        description="Learn about Adina's Crafts - handcrafted scented candles and resin designs made with love in the UK. Our story, values, and commitment to quality."
        keywords="about Adina's Crafts, handmade candles UK, artisan candle maker, candle business UK"
        url="/about"
      />
      <Navbar cartCount={cartCount} />

      {/* Hero */}
      <section className="bg-black py-20 text-white text-center border-b border-gray-800">
        <div className="container mx-auto px-6">
          <h1 className="text-5xl md:text-6xl font-serif font-bold mb-4 text-amber-400">Our Story</h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Crafting memories through artisan candles and resin designs
          </p>
        </div>
      </section>

      {/* About Content */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gray-900 border border-gray-800 rounded-2xl shadow-xl p-8 md:p-12 mb-12">
              <h2 className="text-4xl font-serif font-bold text-amber-400 mb-6">
                Welcome to Adina's Crafts
              </h2>
              <div className="prose prose-lg max-w-none text-gray-300 space-y-4">
                <p>
                  At Adina's Crafts, we believe that every home deserves to be filled with warmth, 
                  fragrance, and beauty. Our journey began with a simple passion for creating unique, 
                  handcrafted candles and resin designs that bring joy to everyday life.
                </p>
                <p>
                  Each product is lovingly made by hand using premium, natural materials. We take pride 
                  in our attention to detail and commitment to quality, ensuring that every candle not 
                  only looks beautiful but also fills your space with delightful aromas.
                </p>
                <p>
                  From classic pillar candles to whimsical shaped designs, our collection celebrates 
                  creativity and craftsmanship. We're dedicated to sustainable practices and use eco-friendly 
                  materials whenever possible.
                </p>
              </div>
            </div>

            {/* Values */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-gray-900 border border-gray-800 p-8 rounded-2xl shadow-lg text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-400 rounded-full mb-4">
                  <Sparkles className="w-8 h-8 text-black" />
                </div>
                <h3 className="text-xl font-serif font-bold text-amber-400 mb-3">Handcrafted</h3>
                <p className="text-gray-400">
                  Every item is carefully crafted by hand with love and attention to detail
                </p>
              </div>

              <div className="bg-gray-900 border border-gray-800 p-8 rounded-2xl shadow-lg text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-400 rounded-full mb-4">
                  <Heart className="w-8 h-8 text-black" />
                </div>
                <h3 className="text-xl font-serif font-bold text-amber-400 mb-3">Made with Love</h3>
                <p className="text-gray-400">
                  We pour our passion into every creation to bring warmth to your home
                </p>
              </div>

              <div className="bg-gray-900 border border-gray-800 p-8 rounded-2xl shadow-lg text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-400 rounded-full mb-4">
                  <Award className="w-8 h-8 text-black" />
                </div>
                <h3 className="text-xl font-serif font-bold text-amber-400 mb-3">Quality First</h3>
                <p className="text-gray-400">
                  Premium materials and rigorous quality standards in every product
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;